<div id="search">
  <div class="toolbar" [style]="{ top }">
    <app-search-toolbar [(searchDisplay)]="searchDisplay" />
  </div>
  @if (searchDisplay === 'list') {
    <app-listing [isSearch]="true" [contentType]="searchedContentType" />
    <app-listing [isSearch]="true" [contentType]="ContentTypes.Playlist" />
  } @else {
    <app-search-map />
  }
</div>
